var _rect, _rect2, _path, _path2, _circle, _path3, _path4, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 160,
    viewBox: "0 0 320 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 304,
    height: 152,
    transform: "translate(8 8)",
    fill: "#A5B0B7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 46,
    width: 160,
    height: 61,
    rx: 8,
    fill: "#4C6170"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M166.017 62.9005C166.057 63.2063 169.266 61.7729 171.252 60.3019C170.327 62.5451 169.499 63.6686 167.513 65.5007C169.47 65.218 170.483 64.9939 172 64.3854C170.615 66.8072 169.589 67.6015 167.513 68.469C169.502 78.4169 162.329 89.3381 152.93 92.8869C145.735 95.7715 137.06 96.0605 129.013 91.4931C129.008 91.4906 129.004 91.4881 129 91.4855C129.004 91.488 129.009 91.4905 129.013 91.4931C129.578 91.7582 138.684 90.8412 140.936 87.8132C140.728 87.9092 139.444 87.453 137.974 86.6293C135.777 85.3984 133.166 83.3467 133.113 81.0909C134.296 81.4773 135.415 81.3968 136.114 81.2726C134.016 80.6945 128.998 74.4968 130.122 72.5526C131.903 73.1129 132.744 73.2679 133.595 73.2945C131.808 72.1714 128.349 63.845 131.617 61.7868C131.402 62.4675 139.035 68.0367 139.47 67.8186C140.063 68.2823 146.993 71.6746 149.939 70.3252C147.521 60.6892 162.846 56.8628 166.017 62.9005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111 61.3636V55H101.93C97.5439 55.9976 96.0528 57.9685 94.8028 63.5909V70.5909H88V77.9091H94.8028V97H103.225V77.9091H109.38L110.352 70.5909H103.225V63.9091C103.225 63.2727 104.845 61.3636 106.141 61.3636H111Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 194.916,
    cy: 56.7341,
    r: 4.73414,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190.971 66.2031H198.466V93.819H190.971V66.2031Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.274 66.2031H204.384V93.819H212.274V78.0385C212.967 75.047 215.134 73.379 218.192 73.2575C220.935 73.2141 222.859 74.7409 224.11 78.0385V93.819H232V74.0934C231.073 69.7113 229.706 67.9125 225.293 66.2031C221.887 65.4146 220.078 65.4386 217.009 66.2031C214.568 67.331 213.513 68.1006 212.274 69.7537V66.2031Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 151,
    width: 304,
    height: 9,
    fill: "#9B1926"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/social-media.0ae774cd5fb78ba015a99d103f38a67e.svg";
export { ForwardRef as ReactComponent };